import React, { useEffect, useState } from 'react';
import api from '../../utils/api';

const TYPE_OPTS = ['info','warning','success','promo'];
const TYPE_COLORS = { info:'#5bc8ff', warning:'#f5c400', success:'#10b981', promo:'#a78bfa' };
const TYPE_ICONS  = { info:'ℹ️', warning:'⚠️', success:'✅', promo:'🎉' };
const empty = { message:'', type:'info', link:'', linkText:'', isActive:true };

export default function AdminAnnouncements() {
  const [anns, setAnns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(empty);
  const [saving, setSaving] = useState(false);

  const load = () => api.get('/announcements/admin').then(({data})=>setAnns(data.announcements||[])).finally(()=>setLoading(false));
  useEffect(()=>{load();},[]);

  const openAdd = () => { setEditing(null); setForm(empty); setModal(true); };
  const openEdit = (a) => { setEditing(a._id); setForm({message:a.message,type:a.type,link:a.link||'',linkText:a.linkText||'',isActive:a.isActive}); setModal(true); };

  const handleSave = async (e) => {
    e.preventDefault(); setSaving(true);
    try {
      if (editing) await api.put(`/announcements/${editing}`, form);
      else await api.post('/announcements', form);
      setModal(false); load();
    } catch(err){ alert(err.response?.data?.message||'Error'); }
    finally { setSaving(false); }
  };

  const toggle = async (id, isActive) => {
    await api.put(`/announcements/${id}`, { isActive: !isActive });
    load();
  };

  const remove = async (id) => {
    if (!window.confirm('Delete this announcement?')) return;
    await api.delete(`/announcements/${id}`); load();
  };

  return (
    <div>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:24}}>
        <div>
          <h1 style={{fontFamily:'var(--font-display)',fontSize:24}}>ANNOUNCEMENTS</h1>
          <p style={{color:'var(--text-secondary)',fontSize:13,marginTop:4}}>Manage the announcement banner shown at the top of the site</p>
        </div>
        <button className="btn btn-primary" onClick={openAdd}>+ New Announcement</button>
      </div>

      {/* Preview */}
      <div style={{background:'var(--bg-secondary)',border:'1px solid var(--border)',borderRadius:12,padding:'14px 20px',marginBottom:24}}>
        <div style={{fontSize:12,color:'var(--text-muted)',marginBottom:8,fontFamily:'var(--font-display)',letterSpacing:'0.08em'}}>SITE PREVIEW</div>
        {anns.filter(a=>a.isActive).length === 0
          ? <div style={{color:'var(--text-muted)',fontSize:13,textAlign:'center',padding:'10px 0'}}>No active announcements — banner is hidden</div>
          : anns.filter(a=>a.isActive).map(a=>(
            <div key={a._id} style={{background:`rgba(${a.type==='warning'?'245,196,0':a.type==='success'?'16,185,129':a.type==='promo'?'124,58,237':'0,136,204'},0.1)`,border:`1px solid ${TYPE_COLORS[a.type]}44`,borderRadius:8,padding:'10px 14px',display:'flex',alignItems:'center',gap:10,marginBottom:6}}>
              <span style={{fontSize:16}}>{TYPE_ICONS[a.type]}</span>
              <span style={{color:TYPE_COLORS[a.type],fontSize:13,fontWeight:600,flex:1}}>{a.message}</span>
              {a.linkText&&<span style={{color:'#f5c400',fontSize:12}}>{a.linkText} →</span>}
            </div>
          ))
        }
      </div>

      {loading ? <div className="loading-spinner"><div className="spinner"/></div> : (
        <div style={{display:'flex',flexDirection:'column',gap:12}}>
          {anns.length===0 && <div style={{textAlign:'center',padding:'60px 20px',color:'var(--text-secondary)'}}><div style={{fontSize:40,marginBottom:12}}>📢</div><p>No announcements yet.</p></div>}
          {anns.map(a=>(
            <div key={a._id} className="card" style={{display:'flex',alignItems:'center',gap:16,borderLeft:`3px solid ${TYPE_COLORS[a.type]}`}}>
              <span style={{fontSize:24,flexShrink:0}}>{TYPE_ICONS[a.type]}</span>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontWeight:600,fontSize:14,marginBottom:4,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{a.message}</div>
                <div style={{display:'flex',gap:10,fontSize:12,color:'var(--text-muted)'}}>
                  <span style={{textTransform:'capitalize',color:TYPE_COLORS[a.type]}}>{a.type}</span>
                  {a.link&&<span>🔗 {a.link}</span>}
                  <span>{new Date(a.createdAt).toLocaleDateString()}</span>
                </div>
              </div>
              <div style={{display:'flex',gap:8,flexShrink:0}}>
                <button onClick={()=>toggle(a._id,a.isActive)} className={`btn btn-sm ${a.isActive?'btn-danger':'btn-primary'}`} style={{fontSize:12}}>
                  {a.isActive?'🔴 Hide':'🟢 Show'}
                </button>
                <button className="btn btn-secondary btn-sm" onClick={()=>openEdit(a)}>Edit</button>
                <button className="btn btn-danger btn-sm" onClick={()=>remove(a._id)}>🗑</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {modal&&(
        <div className="modal-overlay" onClick={()=>setModal(false)}>
          <div className="modal" style={{maxWidth:520}} onClick={e=>e.stopPropagation()}>
            <button className="modal-close" onClick={()=>setModal(false)}>✕</button>
            <h2 style={{fontFamily:'var(--font-display)',fontSize:20,marginBottom:24}}>{editing?'Edit':'New'} Announcement</h2>
            <form onSubmit={handleSave}>
              <div className="form-group"><label>Type</label>
                <div style={{display:'flex',gap:8,marginTop:6}}>
                  {TYPE_OPTS.map(t=>(
                    <button key={t} type="button" onClick={()=>setForm({...form,type:t})} style={{flex:1,padding:'8px',borderRadius:8,border:`1px solid ${form.type===t?TYPE_COLORS[t]:'var(--border)'}`,background:form.type===t?`rgba(${t==='warning'?'245,196,0':t==='success'?'16,185,129':t==='promo'?'124,58,237':'0,136,204'},0.1)`:'transparent',color:form.type===t?TYPE_COLORS[t]:'var(--text-secondary)',cursor:'pointer',fontSize:18}}>
                      {TYPE_ICONS[t]}
                    </button>
                  ))}
                </div>
              </div>
              <div className="form-group"><label>Message *</label><input value={form.message} onChange={e=>setForm({...form,message:e.target.value})} placeholder="Announcement text..." required/></div>
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:14}}>
                <div className="form-group"><label>Link URL</label><input value={form.link} onChange={e=>setForm({...form,link:e.target.value})} placeholder="https://..."/></div>
                <div className="form-group"><label>Link Text</label><input value={form.linkText} onChange={e=>setForm({...form,linkText:e.target.value})} placeholder="Click here"/></div>
              </div>
              <label style={{display:'flex',alignItems:'center',gap:8,cursor:'pointer',color:'var(--text-secondary)',marginBottom:20}}>
                <input type="checkbox" checked={form.isActive} onChange={e=>setForm({...form,isActive:e.target.checked})} style={{width:'auto'}}/> Show on site immediately
              </label>
              <div style={{display:'flex',gap:12}}>
                <button type="submit" className="btn btn-primary" style={{flex:1}} disabled={saving}>{saving?'Saving...':editing?'Update':'Create'}</button>
                <button type="button" className="btn btn-secondary" onClick={()=>setModal(false)} style={{flex:1}}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
